import { useEffect, useState } from 'react';

/**
 * Renvoie une version "debounced" d'une valeur : elle ne change qu'après
 * `delay` ms d'inactivité. Utile pour lier un champ de recherche à une
 * requête API sans la déclencher à chaque keystroke.
 *
 * @template T
 * @param {T} value - Valeur source (généralement le state du champ).
 * @param {number} [delay=300] - Délai en millisecondes.
 * @returns {T} Valeur retardée.
 */
export const useDebouncedValue = (value, delay = 300) => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(handle);
  }, [value, delay]);

  return debounced;
};

export default useDebouncedValue;
